export default {
  profile: '/profile',

  datasources: {
    list: '/datasources',
    summary: '/datasources/${dataSourceType}',
    detail: '/datasources/${dataSourceType}/${dataSourceKey}',
    view: '/datasources/${dataSourceType}/${dataSourceKey}/${dataSourceView}?backTo=${backTo}',
    card: '/datasources/${dataSourceType}/${dataSourceKey}/dashboards/${dashboardId}/card/${cardId}?schemaId=${schemaId}&filterId=${filterId}',
    editCard:
      '/datasources/${dataSourceType}/${dataSourceKey}/dashboards/${dashboardId}/card/${cardId}?action=edit&schemaId=${schemaId}&filterId=${filterId}',
    copyCard:
      '/datasources/${dataSourceType}/${dataSourceKey}/dashboards/${dashboardId}/card/${cardId}?action=copy&schemaId=${schemaId}',
    respondentDetail:
      'datasources/${dataSourceType}/${dataSourceKey}/${dataSourceView}/analytics/respondents/${respondentKey}/detail?responseDate=${responseDate}&schemaId=${schemaId}',
    respondentDetailParam:
      'datasources/${dataSourceType}/${dataSourceKey}/${dataSourceView}/analytics/respondents/${respondentKey}/detail?responseDate=${responseDate}&schemaId=${schemaId}&backTo=${backTo}',
  },

  settings: {
    masterData: '/settings/setup/masterdata',
    masterDataSetup: '/settings/setup/masterdata/new',
    masterDataRecords: '/settings/setup/masterdata/${id}/records',
    masterDataRecordsNew: '/settings/setup/masterdata/${id}/records?new=true',
    hierarchy: '/settings/setup/hierarchy',
    hierarchyDetail: '/settings/setup/hierarchy/${id}/',
    hierarchySetup: '/settings/setup/hierarchy/new',
    hierarchySetupDetail: '/settings/setup/hierarchy/new/${id}',
    uploadSetupDetail: '/settings/setup/hierarchy/new/${id}?type=${type}',
    hierarchyDraftList: '/settings/setup/hierarchy/${hierarchyId}/drafts',
    hierarchyDraftDetail:
      '/settings/setup/hierarchy/${hierarchyId}/drafts/${draftId}',
    hierarchyVersionList: '/settings/setup/hierarchy/${hierarchyId}/versions',
    hierarchyVersionDetail:
      '/settings/setup/hierarchy/${hierarchyId}/versions/${versionId}/',

    setup: {
      roles: '/settings/setup/roles',
      rules: '/settings/setup/assignments',
    },

    people: '/settings/setup/people/',
    users: '/settings/setup/users',

    rolesNew: '/settings/roles/new',
    rolesPeople: '/settings/roles/${id}/people',

    user: {
      details: '/settings/users/${id}/details',
    },

    roles: {
      index: '/settings/roles/${id}',
      new: '/settings/roles/new',
    },

    assignments: {
      index: '/settings/rules/${id}',
      new: '/settings/rules/new',
    },
  },

  dashboards: {
    cx: 'dashboards/cx',
    base: '/dashboards',
    summary: '/dashboards/${dashboardId}',
    card: '/dashboards/${dashboardId}/card/${cardId}',

    editDashboard: '/dashboards/${dashboardId}?action=edit',
    newDashboard: '/dashboards/${dashboardId}?action=new',
    copyDashboard: '/dashboards/${dashboardId}?action=copy',
    createNewDashboard: '/dashboards/new',

    editCard: '/dashboards/${dashboardId}/card/${cardId}?action=edit',
    moveCard: '/dashboards/${dashboardId}/card/${cardId}?action=move',
    copyCard: '/dashboards/${dashboardId}/card/${cardId}?action=copy',
    deleteCard: '/dashboards/${dashboardId}/card/${cardId}?action=delete',
    newCard: '/dashboards/${dashboardId}/card/new/${cardType}',
    schedule: '/dashboards/${dashboardId}/schedule/${scheduleId}',
  },

  behavioral: {
    page: 'behavioral/page?pageA=${pageId}',
    compare: 'behavioral/page/compare?pageA=${pageId}',
  },

  primary: {
    dashboards: '/dashboards/cx',
    settings: '/settings',
  },

  analyze: {
    behavioral: {
      home: `/analyze/behavioral`,
      page: '/analyze/behavioral/page?pageA=${pageId}',
      compare: '/analyze/behavioral/page/compare?pageA=${pageId}',
    },
  },
};
